import { logWrapper } from '../../utils';

export default {
  chatbotController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    '$window',
    '$sce',
    'authService',
    'chatbotService',
    'ragIntegrationService',
    'webApiSettings',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      $window,
      $sce,
      authService,
      chatbotService,
      ragIntegrationService,
      webApiSettings,
    ) {
      'use strict';

      function toggleChat () {
        $scope.isExpanded = !$scope.isExpanded;
      }

      function handleUri () {
        var loggedCompany = authService.getLoggedCompany();
        if (loggedCompany !== null) {
          chatbotService
            .getUri(Number(loggedCompany.IdCompany), `DDv4-${webApiSettings.buildConfiguration}`)
            .then(
              function (data) {
                $rootScope.chatbotUri = $sce.trustAsResourceUrl(data.Uri);
              }
            );
        }
      }

      $rootScope.$on('USER_LOADED', function () {
        handleCanShowChat();
      });

      function handleCanShowChat () {
        handleUri();

        if ($rootScope.chatbotLoaded) {
          $scope.canShowChat = $rootScope.canShowChat;
          return;
        }

        var loggedCompany = authService.getLoggedCompany();

        if (!loggedCompany) return;

        if ($rootScope.chatbotLoading) return;

        $rootScope.chatbotLoading = true;

        ragIntegrationService
          .getProductCompany(
            Number(loggedCompany.IdCompany),
            `DDv4-${webApiSettings.buildConfiguration}`
          )
          .then(function (data) {

            $rootScope.canShowChat = data.ProductCompany.IsEnabled;
            $scope.canShowChat = $rootScope.canShowChat;

            $rootScope.chatbotLoaded = true;

          })
          .finally(() => {
            $rootScope.chatbotLoading = false;
          });
      }

      function handleKeydown () {
        // Only add the listener once
        if (!$scope.keydownListenerAdded) {
          // Close the chat if the Escape key is pressed
          $window.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
              $scope.$apply(function () {
                $scope.isExpanded = false;
              });
            }
          });
          $scope.keydownListenerAdded = true; // Flag to prevent multiple listeners
        }
      }

      function run() {
        try {
          $scope.isExpanded = false;

          $scope.toggleChat = logWrapper(
            toggleChat,
            runtimeConstant.isDebugControllersInternals
          );

          $scope.handleUri = logWrapper(
            handleUri,
            runtimeConstant.isDebugControllersInternals
          );

          $scope.handleCanShowChat = logWrapper(
            handleCanShowChat,
            runtimeConstant.isDebugControllersInternals
          );

          $scope.handleKeydown = logWrapper(
            handleKeydown,
            runtimeConstant.isDebugControllersInternals
          );

          $scope.handleKeydown();
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
